/**
 * @generated SignedSource<<99099a8afc917a3ecd5ef3c7dee364dc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChatThreadItem_ChatMessage$data = {
  readonly deletedAt: string | null | undefined;
  readonly editedAt: string | null | undefined;
  readonly generatedByAi: boolean | null | undefined;
  readonly id: string;
  readonly jobApplicationEvaluation: {
    readonly id: string;
    readonly jobApplication: {
      readonly job: {
        readonly slug: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly label: string | null | undefined;
  readonly sender: {
    readonly firstName?: string | null | undefined;
    readonly self?: boolean | null | undefined;
  };
  readonly " $fragmentType": "ChatThreadItem_ChatMessage";
};
export type ChatThreadItem_ChatMessage$key = {
  readonly " $data"?: ChatThreadItem_ChatMessage$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChatThreadItem_ChatMessage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChatThreadItem_ChatMessage",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deletedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "editedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "generatedByAi",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "JobApplicationEvaluation",
      "kind": "LinkedField",
      "name": "jobApplicationEvaluation",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "JobApplication",
          "kind": "LinkedField",
          "name": "jobApplication",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Job",
              "kind": "LinkedField",
              "name": "job",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "slug",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "sender",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "self",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstName",
              "storageKey": null
            }
          ],
          "type": "User",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ChatMessage",
  "abstractKey": null
};
})();

(node as any).hash = "8b4d990f40979486824ce79b6872a017";

export default node;
